import Empty from '../../components/base/Empty';
import ReportsPage from './components/ReportsPage';

const routes = [
  {
    path: '/reports-page/:page?',
    name: 'menu.reports-page',
    icon: 'menu.reports-page',
    customIcon: true,
    loginRequired: true,
    component: ReportsPage,
    weight: 101,
    permission: ['frontend_menu_exports'],
    children: [],
  },
];

export default routes;
